<div
    class="gene-chip"
    [class.clickable]="clickable"
    [style.border-color]="borderColor"
    [style.color]="textColor"
    [style.background-color]="backgroundColor"
    (click)="onClick()"
>
    <ng-content></ng-content>
    @if(hasLabel){
        <span>{{ label }}</span>
    }
</div>
